import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Progress,
  CardFooter,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import moment from "moment";
import { GoArrowDown } from "react-icons/go";
import "react-circular-progressbar/dist/styles.css";
import StatusBadge from "../Badges/StatusBadge";

const StudentGy25FinalExamModule = ({
  exam,
  calcPercentage,
  runModule,
  intl,
  courseUploads,
}) => {
  const [variantsIsOpen, setVariantsIsOpen] = useState(false);
  const [docDropDownOpen, setDocDropDownOpen] = useState(false);

  const getLockedVariants = () => {
    if (exam.isLocked) {
      return exam.finalExamVariants.sort(
        (a, b) => new Date(b.lastRun) - new Date(a.lastRun)
      );
    } else {
      return exam.finalExamVariants
        .filter((v) => v.isLocked)
        .sort((a, b) => new Date(b.lastRun) - new Date(a.lastRun));
    }
  };

  const getUnlockedVariants = () => {
    if (exam.isLocked) {
      return [];
    } else {
      return exam.finalExamVariants
        .filter((v) => !v.isLocked)
        .sort((a, b) => new Date(b.lastRun) - new Date(a.lastRun));
    }
  };

  let modDocstoggle = () => {
    setDocDropDownOpen((prev) => !prev);
  };

  const showDocumentOrLink = () => {
    if (courseUploads.length > 0) {
      return (
        <Dropdown isOpen={docDropDownOpen} toggle={modDocstoggle}>
          <DropdownToggle
            color="secondary"
            className="doc-dropdown-toggle"
            outline
            caret
          >
            <FormattedMessage id="Documents" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            {courseUploads.map((doc) => {
              return documentItems(doc);
            })}
          </DropdownMenu>
        </Dropdown>
      );
    } else return null;
  };

  const documentItems = (doc) => {
    if (doc.fileUrl) {
      return (
        <DropdownItem key={doc.id}>
          <a href={doc.fileUrl}>{doc.value}</a>
        </DropdownItem>
      );
    } else {
      return (
        <DropdownItem key={doc.id}>
          <a href={doc.value}>{doc.value}</a>
        </DropdownItem>
      );
    }
  };

  const VariantCard = ({ variant, locked }) => {
    return (
      <>
        <Card
          className={
            locked
              ? "mb-3 final-exam-variant-card--disabled"
              : "mb-3 final-exam-variant-card"
          }
        >
          <CardBody>
            <Row>
              <Col xl="9" lg="8" md="5" sm="6">
                <div className="d-flex">
                  <CardTitle className="student-module-item--Title">
                    {variant.name}
                  </CardTitle>
                  <Col className="align-content-center">
                    <span
                      title={intl.formatMessage({
                        id: "StatusForTestModule",
                      })}
                    >
                      <StatusBadge
                        className="px-1"
                        status={variant.status}
                        isGy25FinalExam={true}
                      />
                    </span>
                  </Col>
                </div>
                {variant.runAt && (
                  <Row className="mb-4">
                    <Col className="ps-0">
                      <small className="text-muted">
                        <FormattedMessage id="Opened" />
                        <span className="ms-1">
                          {moment(variant.runAt, "YYYY-MM-DD HH:mm").fromNow()}
                        </span>
                      </small>
                    </Col>
                  </Row>
                )}

                {locked && (
                  <Row className="horizontal-progress align-items-center">
                    <Col
                      lg="6"
                      className="ps-0 pe-4"
                      style={{ maxWidth: "330px" }}
                    >
                      <Progress
                        className={
                          locked
                            ? "progress-student--score--disabled"
                            : "progress-student--score"
                        }
                        value={variant.score ?? 0}
                        max={variant.maxScore}
                      />
                    </Col>
                    <Col className="flex-grow-0 ps-0 text-nowrap">
                      <span className="text-muted score-label">
                        <span>{variant.scoreInPercent}</span>
                        % <FormattedMessage id="ModulePoints" />
                      </span>
                    </Col>
                  </Row>
                )}
              </Col>

              <Col className="align-content-center">
                <Row
                  title={
                    locked
                      ? intl.formatMessage({
                          id: "YourTeacherLockedThisExamError",
                        })
                      : intl.formatMessage({
                          id: "StartExam",
                        })
                  }
                  className="me-0 justify-content-end gap-3"
                >
                  <Col
                    className="text-center"
                    style={{
                      maxWidth: "90px",
                    }}
                  >
                    <div className="d-flex flex-column align-items-center">
                      <img
                        style={{
                          width: "55px",
                          cursor: !locked ? "pointer" : "not-allowed",
                        }}
                        src={
                          locked ? "img/Locked_exam.svg" : "img/Slutprov.svg"
                        }
                        alt="Start exam"
                        onClick={(event) => {
                          if (!locked) {
                            runModule(
                              event,
                              exam.id,
                              "scorm",
                              exam.url,
                              variant.id
                            );
                          }
                        }}
                      />
                      <div
                        className="text-nowrap"
                        style={{
                          marginTop: "1px",
                          color: locked ? "rgba(79, 96, 101, 0.5)" : "#4f6065",
                        }}
                      >
                        <Col>
                          <FormattedMessage id="StartExam" />
                        </Col>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </>
    );
  };

  return (
    <Card className="student-final-exam-card">
      <div className="d-flex">
        <h2 className="student-module-subheading mt-1">{exam.name}</h2>
        <Col className="align-content-center">
          {exam.finalExamVariants.length > 1 ? (
            <span>
              <FormattedMessage
                values={{
                  count: exam.finalExamVariants.length,
                }}
                id="MultipleExamsNumberOfExams"
              />
            </span>
          ) : (
            <span
              title={intl.formatMessage({
                id: "StatusForTestModule",
              })}
            >
              <StatusBadge
                status={exam.finalExamVariants[0].status}
                isGy25FinalExam={true}
              />
            </span>
          )}
        </Col>
      </div>
      <Row className="mt-3">
        {exam.lastRun && (
          <Col>
            <small className="text-muted">
              <FormattedMessage id="Opened" />
              <span className="ms-1">
                {moment(exam.lastRun, "YYYY-MM-DD HH:mm").fromNow()}
              </span>
            </small>
          </Col>
        )}
      </Row>
      {exam.finalExamVariants.filter((v) => !v.isLocked).length > 0 &&
      !exam.isLocked ? (
        getUnlockedVariants().map((variant) => (
          <VariantCard variant={variant} locked={false} />
        ))
      ) : (
        <Row>
          <Col>
            <p className="lead">Du har inga upplåsta slutprov.</p>
          </Col>
        </Row>
      )}

      {exam.finalExamVariants.filter((v) => v.isLocked).length > 0 && (
        <CardFooter className="pb-0 pt-0 student-gy25FinalExam-footer">
          <span
            onClick={() => setVariantsIsOpen(!variantsIsOpen)}
            className="exam-variants-toggle"
          >
            <h5 className="mb-0 text-muted text-nowrap">
              {variantsIsOpen ? "Dölj låsta" : "Visa låsta"}
            </h5>
            <GoArrowDown
              size={18}
              className={` text-muted student-module-dropdown-caret ${
                variantsIsOpen ? "student-module-dropdown-caret-rotated" : ""
              }`}
            />
          </span>
        </CardFooter>
      )}
      <Collapse isOpen={variantsIsOpen}>
        {getLockedVariants().map((variant) => (
          <VariantCard variant={variant} locked={true} />
        ))}
      </Collapse>
      <Row>
        <Col>{showDocumentOrLink()}</Col>
      </Row>
    </Card>
  );
};
export default injectIntl(StudentGy25FinalExamModule);
